import defaultConfig from './config.default';
import * as enterprises from './config';
import { Config } from './config.interface';

export default {
  default: defaultConfig,
  ...enterprises,
} as { [key: string]: Config };
